'use strict';
import { addBrowserClasses } from './modules/_utils';


document.addEventListener('DOMContentLoaded', function() {


  document.getElementsByClassName('no-js')[0].classList.remove('no-js');

  // Common functions
  addBrowserClasses();

  // Cookie consent
  const acceptBtn = document.getElementById('accept-all-btn');
  const cookieBanner = document.getElementById('cookie-consent');

  let consent = localStorage.getItem('userConsent');
  if (!consent && cookieBanner) {
    cookieBanner.style.display = "flex";
  }

  if (acceptBtn) {
    acceptBtn.addEventListener("click", () => {
      localStorage.setItem("userConsent", "accepted");
      cookieBanner.style.display = 'none';
    });
  }


  if (document.getElementById('hero-video')) {
    var player = videojs('hero-video');

    player.ready(function() {
      var promise = player.play();

      if (promise !== undefined) {
        promise.then(function() {
          jQuery('.vjs-play-control').removeClass('vjs-paused');
          jQuery('.vjs-play-control').addClass('vjs-playing');
        }).catch(function(error) {
          // Autoplay was prevented.
        });
      }
    });

  }

  const menuBtn = document.getElementById("mobile-menu-btn");
  const navMain = document.getElementById("nav-main");
  const overlay = document.getElementById("overlay");
  const desktopOverlay = document.getElementById("overlay-desktop");
  const hasSub = document.querySelector(".has-sub");
  const hasSubLink = document.querySelector(".has-sub > a");
  const subMenu = document.querySelector(".sub-menu");

  const toggleMenu = () => {
    menuBtn.classList.toggle("open");
    navMain.classList.toggle("open");
    overlay.classList.toggle("open");
  }
  const closeMenu = () => {
    menuBtn.classList.remove("open");
    navMain.classList.remove("open");
    overlay.classList.remove("open");

  }
  menuBtn.addEventListener('click', () => toggleMenu());

  document.addEventListener("keyup", function(e) {
    if (e.key === "Escape") closeMenu();
  });

  // Always fire closeMenu() at 1024px breakpoint
  const mq = window.matchMedia("screen and (min-width: 1024px)");
  mq.addEventListener("change", (event) => {
    if (event.matches) closeMenu();
  });

  overlay.addEventListener('click', closeMenu);

  hasSubLink.addEventListener('click', (event) => event.preventDefault());

  hasSub.addEventListener('click', () => {
    subMenu.classList.toggle('active');
  });

  const handleMouseEnter = () => {
    desktopOverlay.style.visibility = 'visible';
    desktopOverlay.style.opacity = 1;
  };

  const handleMouseLeave = () => {
    desktopOverlay.style.visibility = 'hidden';
    desktopOverlay.style.opacity = 0;
  };

  hasSub.addEventListener('mouseenter', handleMouseEnter);
  hasSub.addEventListener('mouseleave', handleMouseLeave);


  const linkItems = document.querySelectorAll('.links a');
  linkItems.forEach(link => {
    link.addEventListener('click', () => {
      document.querySelector('.links').querySelectorAll('.active').forEach(el => el.classList.remove('active'));
      link.classList.add('active');
      let activeItem = document.querySelector('.links a.active');
      let activePosition = activeItem.offsetLeft - 16;
      document.querySelector('.links').scrollTo(activePosition, 0);
    })
  })


  const clickToShow = (element) => {
    const images = element.querySelectorAll('img');
    const listItems = element.querySelectorAll('ul li');

    images.forEach((img, index) => img.dataset.value = index);
    listItems.forEach((li, index) => li.dataset.value = index);

    listItems.forEach(li => {
      li.addEventListener('click', () => {
        element.querySelectorAll('.active').forEach(el => el.classList.remove('active'));
        images.forEach(img => {
          if (li.dataset.value === img.dataset.value) {
            li.classList.add('active');
            img.classList.add('active');
          }
        })
      });
    });
  }

  if (document.querySelector('.page-template-wfai')) {
    clickToShow(document.getElementById('wf-planning'));
    clickToShow(document.getElementById('pred-sched'));
    clickToShow(document.getElementById('pred-staff'));
  }

  // Stop any animation/transition while window is being resized
  let resizeTimer;
  window.addEventListener("resize", () => {
    document.body.classList.add("resize-animation-stopper");
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.body.classList.remove("resize-animation-stopper");
    }, 400);
  });


  // hasSub.addEventListener('click', (event) => {
  //   event.preventDefault();
  //   subMenu.classList.toggle('active');
  // });

});
